import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  background-color: ${({ theme }) => theme.colors.darkPurple};
  padding: ${({ theme }) => theme.spacing.lg};
`;

export const Container = styled.div`
  width: 100%;
  margin: 0 auto;
  max-width: ${({ theme }) => theme.layout.formMaxWidth};
  background-color: ${({ theme }) => theme.colors.darkPurple}; 
`;

export const LogoContainer = styled.div`
  text-align: center;
  margin-bottom: ${({ theme }) => theme.spacing.sm}; 
  
  .logo {
    margin: ${({ theme }) => theme.spacing.lg} 0;
    padding: ${({ theme }) => theme.spacing.sm};
    max-width: 320px; 
  }
`;

export const RoleTypeDisplay = styled.h2`
  color: ${({ theme }) => theme.colors.textLight};
  text-transform: capitalize;
  padding: 0 0 ${({ theme }) => theme.spacing.lg};
  font-size: ${({ theme }) => theme.fontSizes.xxl};
  text-align: center;
  font-weight: ${({ theme }) => theme.fontWeights.normal};
  margin-top: 0;
  margin-bottom: ${({ theme }) => theme.spacing.zero};
`;

export const Notice = styled.div`
  color: ${({ theme }) => theme.colors.textLight};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  margin-bottom: ${({ theme }) => theme.spacing.lg};
  line-height: 1.5;
  padding: ${({ theme }) => theme.spacing.md};
  border: 1px solid ${({ theme }) => theme.colors.accent}; 
  border-radius: ${({ theme }) => theme.radii.md};
  background-color: rgba(0,0,0, 0.1); 
`;

export const ConstructionNotice = styled(Notice)`
  text-align: left;
  padding: ${({ theme }) => theme.spacing.lg}; 
  
  p {
    margin-bottom: ${({ theme }) => theme.spacing.md};
    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const StyledForgotPassword = styled.div`
  text-align: left;
  margin-top: ${({ theme }) => theme.spacing.xs};
  margin-bottom: ${({ theme }) => theme.spacing.xl}; 
`;

export const LoginSwitchLink = styled.span`
  cursor: pointer;
  color: ${({ theme }) => theme.colors.lightBlue};
  text-decoration: underline;
  font-size: ${({ theme }) => theme.fontSizes.sm};
  
  &:hover {
    color: ${({ theme }) => theme.colors.white};
  }
`;

export const ErrorMessageDisplay = styled.div`
  text-align: center;
  color: ${({ theme }) => theme.colors.white};
  background-color: rgba(239, 68, 68, 0.2); /* Semi-transparent red background */
  padding: ${({ theme }) => theme.spacing.sm} ${({ theme }) => theme.spacing.md};
  border-radius: ${({ theme }) => theme.radii.md};
  margin-bottom: ${({ theme }) => theme.spacing.lg};
  font-size: ${({ theme }) => theme.fontSizes.xs};
  border: 1px solid rgba(239, 68, 68, 0.5);
  font-weight: ${({ theme }) => theme.fontWeights.medium};
`;

export const BottomLinks = styled.div`
  text-align: center;
  margin-top: ${({ theme }) => theme.spacing.xl}; 

  p {
    cursor: pointer;
    color: ${({ theme }) => theme.colors.textLight};
    margin: ${({ theme }) => theme.spacing.md} 0;
    font-size: ${({ theme }) => theme.fontSizes.sm};
  }

  span {
    text-decoration: underline;
    color: ${({ theme }) => theme.colors.lightBlue};
    font-weight: ${({ theme }) => theme.fontWeights.medium};
    &:hover {
      color: ${({ theme }) => theme.colors.white};
    }
  }
`;
